export default "__VITE_ASSET__BNuoUuTo__"